/*
  src/redux/auth/actions.js

  Created by Justin Chang on 5/17/2017.
*/

import Cookies from 'js-cookie';
import callAuth from '../callAuth';
import callAPI from '../callAPI';
import { callSSO, callSLO } from '../callSAML';
import { guid } from './helpers';
import { RETAILER_ID } from '../../config';
import Promise from 'bluebird';

import {
  SET_AUTH_TOKEN,
  // SET_USER_ID,
  SET_SESSION_ID,
  // FAIL_TO_LOAD_ADJOY_TOKEN_FROM_COOKIES,
  // FAIL_TO_LOAD_ADJOY_USER_ID,
  FAIL_TO_SET_AUTH_TOKEN,

  INVALIDATE_ALL_AUTH,
} from './constants';
// import { SET_CARD_NUMBER } from '../loyalty/constants';

import {
  getAllCardData
} from '../loyalty/actions';
import {setAmplitudeUserId, logAmplitudeRegistrationEvent} from "../../amplitude";

/*
  Load Adjoy Authorization Cookies into State
  @Cookies
    - Auth Token
    - User ID
*/
// export function loadAdjoyAuthFromCookies() {
//   return (dispatch, getState) => {
//     const token  = Cookies.get('adjoy_authToken');
//     const userId = Cookies.get('adjoy_userId');
//
//     if (token === null || token === undefined) {
//       dispatch({type: FAIL_TO_LOAD_ADJOY_TOKEN_FROM_COOKIES});
//     } else {
//       dispatch({
//         type: SET_AUTH_TOKEN,
//         payload: token
//       });
//     }
//
//     if (userId === null || userId === undefined) {
//       dispatch({type: FAIL_TO_LOAD_ADJOY_USER_ID});
//     } else {
//       dispatch({
//         type: SET_USER_ID,
//         payload: userId
//       });
//     }
//   }
// }

/*
  Load MWG and Adjoy Data from Cookies
*/
// export function loadAllAuthFromCookies() {
//   return (dispatch, getState) => {
//     loadAdjoyAuthFromCookies()(dispatch, getState);
//   }
// }









/*
  Create new user via loyalty card number
  @params
    - loyaltyCardNum
  @returns <Object>
    - username: objectId
    - password: generated_pass
*/
export function createNewUser(loyaltyCardNum, opts={}) {
  return (dispatch, getState) => {
    if (loyaltyCardNum === undefined
      || loyaltyCardNum === null
      || loyaltyCardNum.length !== 11)
      throw new Error('Must include a valid loyalty card number.');

    return callAPI({
      ...opts,
      skipTimeout: false,
      method: 'POST',
      path: '/app/v1/pub/userSignup',
      body: {
        deviceId: guid(),
        loyaltyId: loyaltyCardNum,
        retailerId: RETAILER_ID,
      }
    })(dispatch, getState)
    .then(res => {
        setAmplitudeUserId(loyaltyCardNum)
        logAmplitudeRegistrationEvent()
        return res;
    })
    .catch(err => {
      console.error(`Failed to create a new user with this loyalty card number: ${loyaltyCardNum}.`);
      console.error(err);
    });
  }
}

/*
  Get Adjoy Auth Token
  @params
    - username
    - password

  @returns <Object>
    - username: objectId
    - password: generated_pass
*/
export function getAuthToken(username, password, opts={}) {
  return (dispatch, getState) => {
    if (username === undefined || username === null
        || password === undefined || password === null)
      throw new Error('Must include a username and password.');

    return callAuth({
      ...opts,
      method: 'POST',
      path: '/oauth/token',
      body: {
        username: username,
        password: password,
        grant_type: 'password',
        scope: 'APIv3.read APIv3.write'
      }
    })(dispatch, getState)
    .then(res => {
      Cookies.set('adjoy_authToken', res.access_token);

      dispatch({
        type: SET_AUTH_TOKEN,
        payload: res.access_token
      });
      return res;
    })
    .catch(err => {
      dispatch({ type: FAIL_TO_SET_AUTH_TOKEN });
      console.error("Failed to get Auth Token with userId and password.");
      console.error(err);
    });
  }
}

/*
  Create New User Or Sign In

  @params
    - loyaltyCardNum

  How it works:
    1.  Check if loyalty card already has an account
    2a. Create account is necessary
    2b. Sign in
*/
/*
  NOTE:
    There is a problem with registering new cards.
    Two 404's come back. The first is expected - its the first getCardBalance()
    The second is causing the error.
      1. Either the 2nd getCardBalance() is being called to quickly
      2. Or something else.
*/
export function createNewUserOrSignIn(loyaltyCardNum){
  return (dispatch, getState) => {
    if (loyaltyCardNum === undefined || loyaltyCardNum === null || loyaltyCardNum.length !== 11)
      throw new Error('Must include a valid loyalty card number.');
    let isNewUser = false

    return getAllCardData(loyaltyCardNum, {
      allow404: true
    })(dispatch, getState)
      // No Account? Create a new one!
      .then(res => {
        if (res.code === 404) {
          isNewUser = true
          return Promise.resolve()
          .then(() => createNewUser(loyaltyCardNum)(dispatch, getState))
          .then(() => getAllCardData(loyaltyCardNum)(dispatch, getState)); // add card data to cookies and state
        }

        return res;
      })
      .catch(err => {
        console.error("Failed to update Cookies and State with loyalty card info.");
        console.error(err);
      })

      // Get OAuth Token
      .then(res => getAuthToken(res.data.name, res.data.rawPassword)(dispatch, getState))
        .then(res => Promise.resolve(isNewUser))
      .catch((err) => {
        console.error("Failed to change Loyalty Card Number into OAuth Token!");
        console.error(err);
      });
  }
}

/*
  Remove all cookies used in the app
  @Cookies
    - Auth Token
    - User ID
    - MWG Auth
    - Loyalty Card Number
*/
export function invalidateAllAuth(){
  return (dispatch, getState) => {
    Cookies.remove('adjoy_authToken');
    Cookies.remove('adjoy_userId');
    Cookies.remove('adjoy_loyaltyCardNumber');
    Cookies.remove('adjoy_goalAmount');
    dispatch({ type: INVALIDATE_ALL_AUTH });
  }
}

export function getSSOData(sessId, returnUrl, opts={}) {
  return (dispatch, getState) => {
    return callSSO({
      ...opts,
      sessId: sessId,
      returnUrl: returnUrl
    })(dispatch, getState)
      .then(res => {
        const oldSessionId = getState().auth.sessId;
        if (oldSessionId !== sessId) {
          dispatch({
            type: SET_SESSION_ID,
            payload: sessId
          });
        }

        const userInfo = res.UserInfo;
        if (userInfo && userInfo.FSN) {
          console.debug(`Setting Cookies for loyalty card number with ${userInfo.FSN}`);
          Cookies.set('adjoy_loyaltyCardNumber', userInfo.FSN);
        }
        return res;
      })
      .catch(err => {
        console.error("Failed to SSO with Shoprite.");
        console.error(err);
      });
  }
}

export function samlSignOut(opts={}) {
  return (dispatch, getState) => {
    const sessId = getState().auth.sessId;
    const returnUrl = encodeURIComponent(window.location.href);
    return callSLO({
      ...opts,
      sessId: sessId,
      returnUrl: returnUrl
    })(dispatch, getState)
      .then(res => { return res; })
      .catch(err => {
        console.error("Failed to SLO with Shoprite.");
        console.error(err);
      });
  }
}



// WEBPACK FOOTER //
// ./src/redux/auth/actions.js